import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../../../../lib/supabase/supabaseClient";
import {
	JobEntityType,
	PatientEntityType,
	SupabaseTableEnum,
} from "../../../../lib/supabase/supabaseTypes";
import { Logger } from "../../../../lib/logger/Logger";
import { ChevronLeft } from "lucide-react";
import { JobItemComponent } from "../Jobs/job-item.component";
import { Loading } from "@/components/src/animations/loading";

export const PatientPage = () => {
	const { id } = useParams();
	const [patient, setPatient] = useState<PatientEntityType | null>(null);
	const [jobs, setJobs] = useState<JobEntityType[]>([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const fetchPatient = async () => {
		if (!id) return;
		const { data, error } = await supabase
			.from(SupabaseTableEnum.PATIENTS)
			.select()
			.eq("id", id)
			.single();

		if (error) {
			Logger.error(error, {}, "Error fetching Job");
			return;
		}

		setPatient(data);
	};

	const fetchJobs = async () => {
		if (!id) return;
		const { data, error } = await supabase
			.from(SupabaseTableEnum.JOBS)
			.select()
			.eq("patient_id", id);

		if (error) {
			Logger.error(error, {}, "Error fetching Jobs");
			return;
		}

		setJobs(data);
	};

	const fetch = async () => {
		setLoading(true);
		await fetchPatient();
		await fetchJobs();
		setLoading(false);
	};

	useEffect(() => {
		fetch();
	}, [id]);
	const title = patient?.title ?? "";
	const name = `${patient?.first_name ?? ""} ${patient?.last_name ?? ""}`;

	if (loading) {
		return <Loading />;
	}

	return (
		<div className="h-full flex flex-col overflow-y-auto">
			<div className="flex items-center justify-between">
				<label
					onClick={() => navigate(-1)}
					className="text-blue-600 transition-colors active:text-blue-200 items-center flex"
				>
					<ChevronLeft />
					<span className="text-lg normal-case">Zurück</span>
				</label>
			</div>
			<div className="flex justify-center gap-1">
				<div className="flex flex-col gap-1 w-full">
					<div className="text-2xl font-bold text-center flex flex-wrap justify-center">
						<span className="break-after-auto">{title}</span>
						{title && name && <span>&nbsp;</span>}
						<span>{name}</span>
					</div>
					{patient?.birth_date && (
						<div className="text-lg font-bold text-center">
							Geburtsdatum:{" "}
							{new Date(patient?.birth_date).toLocaleDateString(
								"de-CH"
							)}
						</div>
					)}
					<div className="text-lg text-center">Code: {patient?.code}</div>
				</div>
			</div>
			<div className="flex-1 overflow-y-auto mt-2">
					<div className="flex flex-col gap-2">
					<div className="text-xl font-bold text-center">
						{jobs?.length && jobs?.length > 0
							? `Aufträge:`
							: "Keine Aufträge gefunden"}
					</div>
					{jobs?.map((job) => (
						<JobItemComponent
							key={job.id}
							jobTitle={job.title ?? ""}
							jobCode={job.code ?? ""}
							onSelect={() => navigate(`/job/${job.id}`)}
						/>
					))}
				</div>
			</div>
		</div>
	);
};
